import { Component, OnInit } from '@angular/core';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
  selector: 'app-deposit-limit',
  templateUrl: './deposit-limit.component.html',
  styleUrls: ['./deposit-limit.component.scss'],
})
export class DepositLimitComponent implements OnInit {

  public labels: DepositMainLabels;

  constructor(
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
  ){
    this.labels = new DepositMainModel();
  }

  ngOnInit() {}

  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('common').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  navigateTo(page: string) {
		return this.navigator.navigateTo(page, { multipleModals: true });
	}

}
